const vehicles = {
  vehicles: 'Vehículos',

  headerButtons: {
    create: {
      createBtn: 'Crear',
    },

    import: 'Importar',
  },

  import: {
    title: 'Carga de vehículos',
  },

  toast: {
    error: {
      badResponse: '[Vehículo] respuesta incorrecta del servidor',
      edit: {},
      create: {},
    },
    success: {
      edit: {
        resetSuccess: 'Con éxito.',
      },
      create: {},
      delete: {
        default: '[Vehículo] eliminado correctamente',
      },
    },
  },
  table: {
    headers: {
      name: 'Nombre',
      make: 'Fabricante',
      model: 'Modelo',
      year: 'Año',
      color: 'Color',
      pax: 'Máx. Pasajeros',
      minSeats: 'Pasajeros Mínimos',
      supplier: 'Proveedores',
      attributes: 'attributes',
      service: 'service'

    },
    filters: {
      supplier: 'Proveedores',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  deleteModal: {
    header: 'Eliminar vehículos',
    body: 'Está a punto de eliminar {{num}} vehículos.',
  },

  create: {
    successToast: {
      message: '¡Éxito! Vehículo creado!',
    },
    errorToast: {
      message: 'Ocurrió un error. No se pudo crear el vehículo',
    },
  },

  edit: {
    successToast: {
      message: '¡Éxito! Vehículo actualizado!',
    },
    errorToast: {
      message: 'Ocurrió un error. No se pudo actualizar el vehículo',
    },

    suspendButton: {
      actionActivate: 'Reactivar',
      actionDeactivate: 'Suspender',
    },
    suspendModal: {
      popupTitleActive: 'Colgar Vehículo',
      popupTitleDeactivation: 'Reactivar vehículo',
      popupTitleUnsuspend: 'Motivo de remover suspensión',
      popupSubTitleDeactivation: 'Selecciona el motivo de la suspensión',
      popupActionActive: 'Reactivar vehículo',
      popupActionDeactivate: 'Colgar Vehículo',
    },
    activeStatusButton: {
      statusActive: 'Activo',
      statusDeactivate: 'Inactiva',
    },
    formTabs: {
      informationTab: 'Información',
      notesTab: 'Notas',
      historyTab: 'Historia',
      reservationPreferencesTab: 'Preferencias de Reservación',
    },
  },

  form: {
    header: {
      createVehicle: {
        title: 'Crear',
      },

      updateVehicle: {
        title: 'Actualizar',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },
    information: {
      details: {
        header: 'Información general',
        fields: {
          name: 'Nombre',
          site: 'Sitio',
          year: 'Año',
          location: 'Ubicación de inicio',
          make: 'Fabricante',
          model: 'Modelo',
          color: 'Color',
          suppliers: 'Proveedores',
          code: 'ID externo',
          vin: 'VIN',
          productID: 'ID de producto',
          licensePlate: 'Placa de licencia',
          electric: 'Eléctrico',
          connectorType: 'Tipo de conector',
        },
      },
      attributes: {
        header: 'Atributos',
      },
      suppliers: {
        header: 'Proveedores',
        fields: {
          suppliers: 'Proveedores',
        },
      },
      mileageInspection: {
        header: 'Millaje e inspección',
        fields: {
          mileage: 'Millaje',
          mileageLastInspection: 'Millaje en la última revisión',
          lastInspectionDate: 'Fecha de la última revisión',
          nextInspectionDate: 'Próxima fecha de revisión',
        },
      },
      capacity: {
        header: 'Capacidad',
        headerConfigurations: 'Configuraciones de capacidad',
        fields: {
          seats: 'Asientos Máx.',
          minSeats: 'Asientos Mínimos',
          attribute: 'Atributo',
          count: 'Contar',
        },
        btnAddConfig: {
          title: 'Añadir configuración',
        },
      },
      deliveriesDetails: {
        header: 'Detalles de las entregas',
        fields: {
          maxWeight: 'Peso máximo',
          maxVolume: 'Volumen máximo',
        },
      },
      services: {
        header: 'Servicios',
      },
      insurance: {
        header: 'Seguros',
        fields: {
          typeOfInsurance1: 'Tipo de seguro 1',
          typeOfInsurance1_start: 'Fecha de inicio',
          typeOfInsurance1_end: 'Fecha de finalización',
          typeOfInsurance2: 'Tipo de seguro 2',
          typeOfInsurance2_start: 'Fecha de inicio',
          typeOfInsurance2_end: 'Fecha de finalización',
        },
      },
      dimensions: {
        header: 'Dimensiones del vehículo',
      },
      getProductBtn: 'MOSTRAR IDs de producto GETT',
      excludedProfiles: {
        header: 'Perfis Excluídos',
        dualList: {
          profilesList: {
            header: 'Lista de Perfis',
          },
          excludedList: {
            header: 'Perfis Excluídos',
          },
        },
      },
    },
    valdations: {
      name: 'El nombre es obligatorio',
      plateNumber: {
        matches: 'El máximo de pasajeros debe ser un número',
        required: 'Se requiere un máximo de pasajeros',
      },
      service: 'El servicio con es obligatorio',
      pax: {
        matches: 'Pax debe ser un número',
        required: 'Pax es obligatorio',
      },
      minSeats: {
        matches: 'Los Asientos Mínimos deben ser un número',
        required: 'Se requieren un mínimo de asientos',
      },
      model: 'El modelo con es obligatorio',
      color: 'Color con es obligatorio',
      year: {
        matches: 'El año debe ser un número',
        required: 'El año es obligatorio',
      },
      licenseExpDate: 'Se requiere el vencimiento de la licencia',
    },
  },

  statuses: {
    online: 'En línea',
    suspended: 'Suspendido',
    onATrip: 'De viaje',
  },

  totalVehicles: 'Total de vehículos',
};

export default vehicles;
